import React, { Component } from 'react';
import firebase from '../../store/firebase';
import { isBrowser, isMobile } from "react-device-detect";
import { FB_URL } from '../../store/actions/types';
import axios from 'axios';

class Agentlist extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      error: null,
      showAdmin: false,
      collectionsConfig: [],
      data: {},
      newCollectionName: ''
    };
  }

componentDidMount() {
  this.listenerRefs = [];
  this.loadCollectionConfig();
}

componentWillUnmount() {
  this.listenerRefs.forEach(({ ref, callback }) => ref.off('value', callback));
}

// Replaces fetchAllCollections
subscribeAllCollections = () => {
  const { collectionsConfig } = this.state;
  if (!collectionsConfig || collectionsConfig.length === 0) {
    this.setState({ loading: false });
    return;
  }
  let firstLoadCount = 0;
  collectionsConfig.forEach((name) => this.subscribeToCollection(name, () => {
    firstLoadCount += 1;
    if (firstLoadCount === collectionsConfig.length) this.setState({ loading: false });
  }));
};

// Replaces fetchCollection
subscribeToCollection = (collectionName, onFirstLoad) => {
  const ref = firebase.database.ref(collectionName);
  let loaded = false;

  const callback = (snapshot) => {
    const users = this.parseUsers(snapshot.val(), collectionName);
    this.setState((prev) => ({
      data: {
        ...prev.data,
        [collectionName]: { users, error: null, lastUpdated: Date.now() }
      }
    }));
    if (!loaded) { loaded = true; onFirstLoad(); }
  };

  const errorCallback = (err) => {
    console.warn(`⚠️ ${collectionName} listener error:`, err.message);
    this.setState((prev) => ({
      data: {
        ...prev.data,
        [collectionName]: {
          users: prev.data[collectionName]?.users || [],
          error: err.message,
          lastUpdated: prev.data[collectionName]?.lastUpdated
        }
      }
    }));
    if (!loaded) { loaded = true; onFirstLoad(); }
  };

  ref.on('value', callback, errorCallback);
  this.listenerRefs.push({ ref, callback });
};

// Extracted from the old fetchCollection body — pure parsing, no fetch logic
parseUsers = (rawData, collectionName) => {
  if (!rawData) return [];
  const allUsers = Object.keys(rawData).map((key) => {
    const user = rawData[key];
    let isUnsubscribed = false;
    if (user.unsubscribed !== undefined) {
      const val = user.unsubscribed;
      if (val === true || val === 'true' || val === 1 || val === '1') isUnsubscribed = true;
    }
    return {
      id: key,
      name: user.name || 'Unknown',
      lastInteractionDate: user.lastInteractionDate || '',
      totalExchanges: Number(user.totalExchanges) || 0,
      pledgeValue: Number(user.pledgeValue) || 0,
      exchangesSinceConnect: Number(user.exchangesSinceConnect) || 0,
      unsubscribed: isUnsubscribed
    };
  });
  return allUsers.filter((u) => !u.unsubscribed);
};

  // ← MAIN CHANGE: Try to load from database first
loadCollectionConfig = async () => {
  this.setState({ loading: true, error: null });

  try {
    // Add 8-second timeout — if database not yet reconnected, use fallback
    const snapshot = await Promise.race([
      firebase.database.ref('agentCollectionList').once('value'),
      new Promise((_, reject) =>
        setTimeout(() => reject(new Error('DB read timeout')), 8000)
      )
    ]);

    const savedList = snapshot.val();

    if (Array.isArray(savedList) && savedList.length > 0) {
      console.log(`✅ Loaded ${savedList.length} collections from agentCollectionList`);
      this.setState({ collectionsConfig: savedList }, () => {
        this.subscribeAllCollections();
      });
    } else {
      this.useFallbackList();
    }
  } catch (err) {
    console.warn("Could not read agentCollectionList from DB, using fallback:", err.message);
    this.useFallbackList();
  }
};

  useFallbackList = () => {
    const fallbackList = [
      'telegramUsers',
      'telegramMiningUsers',
      'telegramTeamLeadershipUsers',
      'telegramBankingUsers',
      'telegramLiveWellUsers',
      'telegramPowerUtilityUsers',
      'telegramSmallBusinessUsers',
      'telegramWisdomCompanionUsers',
    ];

    console.log("Using fallback list");
    this.setState({ collectionsConfig: fallbackList }, () => {
      this.subscribeAllCollections();
    });
  };

  formatTitle = (collectionName) => {
    let title = collectionName
      .replace(/^telegram/, '')
      .replace(/Users$/, '')
      .replace(/([A-Z])/g, ' $1')
      .trim();
    return title ? `${title} Agent Users` : 'Agent Users';
  };

// fetchCollection = async (collectionName) => {
//   try {
//     const currentUser = firebase.auth.currentUser;
//     console.log(`fetchCollection ${collectionName}: auth uid = ${currentUser?.uid || 'NULL'}`);

//     const snapshot = await Promise.race([
//       firebase.database.ref(collectionName).once('value'),
//       new Promise((_, reject) =>
//         setTimeout(() => reject(new Error('timeout')), 8000)
//       )
//     ]);

//     const rawData = snapshot.val();
//     if (!rawData) {
//       console.log(`No data in ${collectionName}`);
//       return [];
//     }

//     console.log(`Raw records in ${collectionName}: ${Object.keys(rawData).length}`);

//     const allUsers = Object.keys(rawData).map(key => {
//       const user = rawData[key];

//       // ── Improved unsubscribed detection ──
//       let isUnsubscribed = false;

//       if (user.unsubscribed !== undefined) {
//         const val = user.unsubscribed;
//         if (val === true || val === 'true' || val === 1 || val === "1") {
//           isUnsubscribed = true;
//         }
//       }
//       // If field doesn't exist at all → considered subscribed (as per your requirement)

//       return {
//         id: key,
//         name: user.name || 'Unknown',
//         lastInteractionDate: user.lastInteractionDate || '',
//         totalExchanges: Number(user.totalExchanges) || 0,
//         pledgeValue: Number(user.pledgeValue) || 0,
//         exchangesSinceConnect: Number(user.exchangesSinceConnect) || 0,
//         unsubscribed: isUnsubscribed,
//         // For debugging
//         rawUnsubValue: user.unsubscribed,   // temporary
//       };
//     });

//     const filteredUsers = allUsers.filter(user => !user.unsubscribed);

//     // Detailed logging to help you debug
//     const unsubCount = allUsers.length - filteredUsers.length;
//     console.log(`✅ ${collectionName}: ${allUsers.length} total | ${unsubCount} unsubscribed | ${filteredUsers.length} shown`);

//     // Optional: Log some examples of unsubscribed users
//     const unsubExamples = allUsers.filter(u => u.unsubscribed).slice(0, 3);
//     if (unsubExamples.length > 0) {
//       console.log("Unsubscribed examples:", unsubExamples.map(u => ({ 
//         name: u.name, 
//         rawValue: u.rawUnsubValue 
//       })));
//     }

//     return filteredUsers;

//   } catch (err) {
//     console.warn(`⚠️ Could not fetch ${collectionName}:`, err.message);
//     return [];
//   }
// };

  // fetchAllCollections = async () => {
  //   const { collectionsConfig } = this.state;
  //   if (!collectionsConfig || collectionsConfig.length === 0) {
  //     this.setState({ loading: false });
  //     return;
  //   }

  //   try {
  //     const fetchPromises = collectionsConfig.map(name => this.fetchCollection(name));
  //     const results = await Promise.all(fetchPromises);

  //     const dataObj = {};
  //     collectionsConfig.forEach((name, index) => {
  //       dataObj[name] = results[index];
  //     });

  //     this.setState({
  //       data: dataObj,
  //       loading: false,
  //       error: null
  //     });
  //   } catch (err) {
  //     console.error(err);
  //     this.setState({
  //       loading: false,
  //       error: "Some data could not be loaded. Check console for details."
  //     });
  //   }
  // };

  resubscribeAll = () => {
    this.listenerRefs.forEach(({ ref, callback }) => ref.off('value', callback));
    this.listenerRefs = [];
    this.subscribeAllCollections();
  };

  addCollection = async () => {
    const name = this.state.newCollectionName.trim();
    if (!name) {
      alert("Please enter a collection name (e.g. telegramNewAgentUsers)");
      return;
    }

    if (this.state.collectionsConfig.includes(name)) {
      alert("This collection is already in the list.");
      return;
    }

    const updated = [...this.state.collectionsConfig, name];

    try {
      const updates = {};
      updates['/agentCollectionList'] = updated;

      const res = await axios.post(`${FB_URL}/m115-freshcard`, {
        params: { updates }
      });

      if (res.data?.success === true || res.data) {
        console.log(`✅ Added: ${name}`);
        this.setState({ 
          collectionsConfig: updated,
          newCollectionName: '' 
        }, this.resubscribeAll);
      } else {
        alert("Failed to add collection.");
      }
    } catch (err) {
      console.error("Add collection error:", err);
      alert("Could not add collection. Check console.");
    }
  };

  removeCollection = async (collectionToRemove) => {
    if (!window.confirm(`Remove "${collectionToRemove}" from the list?`)) return;

    const updated = this.state.collectionsConfig.filter(c => c !== collectionToRemove);

    try {
      const updates = {};
      updates['/agentCollectionList'] = updated;

      const res = await axios.post(`${FB_URL}/m115-freshcard`, {
        params: { updates }
      });

      if (res.data?.success === true || res.data) {
        console.log(`✅ Removed: ${collectionToRemove}`);
        this.setState({ collectionsConfig: updated }, this.resubscribeAll);
      } else {
        alert("Failed to remove collection.");
      }
    } catch (err) {
      console.error("Remove collection error:", err);
      alert("Could not remove collection. Check console.");
    }
  };

renderTable = (title, collectionState, collectionName) => {
  const { users = [], error, lastUpdated } = collectionState || {};
  return (
    <div key={collectionName} style={{ marginBottom: '50px' }}>
      <h2 style={{ marginBottom: '15px' }}>
        {title}
        <span style={{ fontSize: '15px', color: '#555', marginLeft: '15px' }}>
          ({users.length} active users{lastUpdated ? ` · updated ${new Date(lastUpdated).toLocaleTimeString()}` : ''})
        </span>
      </h2>

      {error && (
        <p style={{ color: '#d32f2f', fontWeight: 'bold' }}>
          ⚠️ Failed to load this collection: {error}
        </p>
      )}

      {users.length === 0 && !error ? (
        <p style={{ color: '#666' }}>No active users in this collection.</p>
      ) : users.length > 0 ? (
        <div style={{ overflowX: 'auto', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
          <table style={{ width: '100%', minWidth: '850px', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ backgroundColor: '#f8f9fa' }}>
                <th style={{ padding: '12px', textAlign: 'left' }}>Name</th>
                <th style={{ padding: '12px', textAlign: 'left' }}>Last Interaction</th>
                <th style={{ padding: '12px', textAlign: 'center' }}>Total Exchanges</th>
                <th style={{ padding: '12px', textAlign: 'center' }}>Pledge Value</th>
                <th style={{ padding: '12px', textAlign: 'center' }}>Exchanges Since Connect</th>
                <th style={{ padding: '12px', textAlign: 'center', color: '#d32f2f' }}>Unsubscribed</th>
              </tr>
            </thead>
            <tbody>
              {users.map(user => (
                <tr key={user.id} style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '12px' }}>{user.name}</td>
                  <td style={{ padding: '12px' }}>{user.lastInteractionDate}</td>
                  <td style={{ padding: '12px', textAlign: 'center' }}>{user.totalExchanges}</td>
                  <td style={{ padding: '12px', textAlign: 'center' }}>{user.pledgeValue}</td>
                  <td style={{ padding: '12px', textAlign: 'center' }}>{user.exchangesSinceConnect}</td>
                  <td style={{ padding: '12px', textAlign: 'center', fontWeight: 'bold', color: '#388e3c' }}>
                    No
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>
  );
};

  render() {
    const { loading, error, collectionsConfig, data, showAdmin, newCollectionName } = this.state;

    if (loading) {
      return <p style={{ textAlign: 'center', padding: '80px' }}>Loading Agent Participation...</p>;
    }

    return (
      <div style={{ padding: '20px', maxWidth: '1400px', margin: '0 auto', fontFamily: 'Arial, sans-serif' }}>
        {isMobile ? <div>&nbsp;</div> : null}

        <h1 style={{ textAlign: 'center', marginBottom: '25px' }}>Agent Users Participation</h1>

        {/* Admin Panel */}
        <div style={{ marginBottom: '30px', border: '1px solid #ddd', borderRadius: '8px', padding: '15px', backgroundColor: '#f9f9f9' }}>
          <div 
            onClick={() => this.setState({ showAdmin: !showAdmin })}
            style={{ cursor: 'pointer', fontWeight: 'bold', fontSize: '16px' }}
          >
            ⚙️ Manage Agent Collections {showAdmin ? '▲' : '▼'}
          </div>

          {showAdmin && (
            <div style={{ marginTop: '15px' }}>
              <div style={{ marginBottom: '15px' }}>
                <input
                  type="text"
                  placeholder="telegramNewAgentUsers"
                  value={newCollectionName}
                  onChange={(e) => this.setState({ newCollectionName: e.target.value })}
                  style={{ padding: '8px', width: '300px', marginRight: '8px' }}
                />
                <button 
                  onClick={this.addCollection}
                  style={{ 
                    padding: '6px 14px', 
                    fontSize: '13px',
                    backgroundColor: '#1a73e8', 
                    color: 'white', 
                    border: 'none', 
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                >
                  Add Collection
                </button>
              </div>

              <p><strong>Active Collections ({collectionsConfig.length})</strong></p>
              <ul>
                {collectionsConfig.map(name => (
                  <li key={name} style={{ marginBottom: '6px' }}>
                    {name}
                    <button 
                      onClick={() => this.removeCollection(name)} 
                      style={{ 
                        marginLeft: '12px', 
                        color: 'red',
                        fontSize: '13px',
                        padding: '3px 10px',
                        background: 'none',
                        border: '1px solid #ddd',
                        borderRadius: '3px',
                        cursor: 'pointer'
                      }}
                    >
                      remove
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        {collectionsConfig.length === 0 && <p>No collections configured.</p>}

      {collectionsConfig.map(name => (
        this.renderTable(this.formatTitle(name), data[name], name)
      ))}

        <button 
          // onClick={this.fetchAllCollections}
          onClick={this.resubscribeAll}
          style={{ 
            padding: '8px 18px', 
            marginTop: '30px', 
            fontSize: '14px',
            backgroundColor: '#34a853',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer'
          }}
        >
          🔄 Refresh All Data
        </button>
      </div>
    );
  }
}

export default Agentlist;